﻿{
  "favoriteBoardmakerSoftware": "Logiciel Boardmaker",
  "planDetailsStartTrial": "Commencez votre période d’essai gratuite qui comprend un accès d’une durée de 30 jours !",
  "community": {
    "summary": "Profitez des avantages de matériels éducatifs prêts à l’emploi et accessibles partagés par des parents, éducateurs et thérapeutes comme vous ! Gagnez du temps en recherchant et filtrant les activités et modèles, puis ajoutez-les tous simplement à votre compte et vous serez ensuite prêt à les éditer et les utiliser avec votre logiciel Boardmaker favori. N’attendez plus pour profiter des 60 000 activités imprimées et interactives GRATUITES et des 500.000 membres de la communauté.",
    "topReasons": {
      "header": "Les raisons principales pour vous inscrire à la communauté myBoardmaker",
      "points": [
        "Partagez les excellentes activités que vous avez créées",
        "Utilisez des fonctions de recherche efficaces pour trouver ce que dont vous avez exactement besoin",
        "Recherchez des activités créées de façon professionnelle par l’équipe éducative de Boardmaker",
        "Recherchez des activités conformes aux normes Common Core",
        "Rejoignez des groupes correspondant à vos intérêts spécifiques"
      ]
    },
    "summaryEnd": "Partagez et explorez du matériel interactif et imprimé qui fournit des soutiens au comportement et encourage l’indépendance de l’élève ainsi que le développement de ses compétences, tout cela GRATUITEMENT.",
    "features": [
      {
        "featureTitle": "Chercher",
        "featureDescription": "Découvrez un programme, des séquentiels visuels, des tableaux de communication, des activités conformes aux normes éducatives et d’autres soutiens adaptés qui ont été développés et utilisés par des parents, thérapeutes et éducateurs."
      },
      {
        "featureTitle": "Partager",
        "featureDescription": "Téléchargez les activités que vous avez créées, participez à des discussions, créez des groupes publics et privés pour partager et bien plus encore."
      },
      {
        "featureTitle": "Utilisation",
        "featureDescription": "Stockez vos activités en ligne et accédez-y à partir de n’importe quel ordinateur."
      },
      {
        "featureTitle": "Association",
        "featureDescription": "Associez-vous aux autres personnes qui enseignent le même sujet ou niveau que vous, échangez des idées avec des parents qui doivent relever les mêmes défis que vous et partagez les solutions que vous avez créées."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 ou plus tard"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 ou plus tard"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 ou plus tard"]
      ],
      "browser": [
        ["Chrome", "v49.0", "en cours"],
        ["Firefox", "v38.0", "en cours"],
        ["Safari", "v11.0", "en cours"],
        ["Edge", "v83.0.478.45", "en cours"],
        ["Internet Explorer", "v10.0", "v11.0 ou plus tard"]
      ]
    }
  },
  "personal": {
    "summary": "Profitez de l’efficacité de Boardmaker chez vous en toute facilité. Un abonnement myBoardmaker privé vous donne la possibilité de jouer un rôle actif dans la réussite de votre enfant en assurant une cohérence entre le domicile, l’école et le lieu de la thérapie afin d’approfondir l'apprentissage au-delà des jours de classe et même de l’année scolaire. Réseautez avec d'autres parents de la communauté Boardmaker pour partager vos créations et obtenir de nombreuses autres idées.",
    "topReasons": {
      "header": "Les raisons principales pour vous inscrire à la communauté myBoardmaker Personal",
      "points": [
        "Importez des activités attrayantes et interactives sur n'importe quel ordinateur ou iPad",
        "Imprimez des activités lorsque vous en avez besoin",
        "En tant que parent, jouez un rôle actif dans l’apprentissage de votre enfant à la maison",
        "Emportez des matériels amusants et attrayants partout où vous en avez besoin et créez ou modifiez des activités à partir de n'importe quel ordinateur"
      ]
    },
    "summaryEnd": "Commencez votre période d’essai gratuite qui comprend un accès complet d’une durée de 30 jours !",
    "features": [
      {
        "featureTitle": "Créer et Éditer",
        "featureDescription": "Créez et modifiez des activités adaptées aux symboles, comme des séquentiels visuels pour planifier votre journée, des livres et du matériel d'apprentissage personnalisés ainsi que des soutiens au comportement ! Avec une bibliothèque de plus de 80 000 symboles parmi lesquels choisir et des nouveaux ajoutés toutes les deux semaines, les possibilités sont infinies. Vous avez besoin d’autre chose ? Utilisez notre option de recherche Web pour importer des fichiers multimédias dans votre projet."
      },
      {
        "featureTitle": "Imprimer et ouvrir",
        "featureDescription": "Imprimez vos propres activités, ou celles que vous trouverez dans la communauté Boardmaker, directement à partir de votre navigateur Web pour les utiliser avec votre enfant. Vous souhaitez améliorer la participation ? Essayez nos modèles et activités interactifs. Les enfants et les parents peuvent facilement effectuer des activités via l'application gratuite Student Center sur leur tablette ou dispositif de communication."
      },
      {
        "featureTitle": "Enseigner et prolonger",
        "featureDescription": "Renforcez les compétences linguistiques et de littéracie de votre enfant grâce à un accès à nos trois programmes pédagogiques faciles à utiliser. Commencez par Core First Learning - un outil pour aider votre enfant à apprendre la signification, l'utilisation et le placement du vocabulaire de base fréquemment utilisé. Idéal pour les personnes utilisant des systèmes de communication augmentative basés sur le vocabulaire de base ou celles qui apprennent à lire ! Appliquez ces nouvelles compétences à la littérature de niveau scolaire en démarrant avec Book Bridge, puis commencez à développer des connaissances générales en explorant l’histoire, la géographie, la vie et la culture avec Expedition Education."
      },
      {
        "featureTitle": "Rechercher et partager",
        "featureDescription": "Pourquoi réinventer la roue ? Choisissez parmi plus de 60 000 activités imprimées et interactives prêtes à l'emploi et GRATUITES et 1 100 groupes publics catégorisés dans la communauté Boardmaker - la plus grande communauté de partage de ce type au monde. Vous pouvez également télécharger les activités que vous avez créées sur votre compte communauté myBoardmaker et les partager avec des parents, thérapeutes ou l'équipe d'assistance de votre élève."
      },
      {
        "featureTitle": "Superviser et suivre",
        "featureDescription": "Supervisez et suivez les progrès de votre enfant pendant qu'il travaille sur les activités pour assurer son succès et vous aider à déterminer l'approche la plus efficace."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 ou plus tard"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 ou plus tard"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 ou plus tard"]
      ],
      "browser": [
        ["Chrome", "v49.0", "en cours"],
        ["Firefox", "v38.0", "en cours"],
        ["Safari", "v11.0", "en cours"],
        ["Edge", "v83.0.478.45", "en cours"],
        ["Internet Explorer", "v10.0", "v11.0 ou plus tard"]
      ]
    }
  },
  "professional": {
    "summary": "Boardmaker Online Professional est le système le plus complet pour les enseignants en éducation spécialisée, les orthophonistes, les ergothérapeutes, les thérapeutes comportementaux et plus encore pour trouver, créer, organiser et fournir des soutiens visuels personnalisés ainsi que des activités de communication et de thérapie basées sur des symboles qui répondent aux besoins des élèves de votre classe ou dont vous avez la charge.",
    "topReasons": {
      "header": "Les raisons principales pour vous inscrire à la communauté myBoardmaker Professional",
      "points": [
        "Gérez et attribuez les activités des élèves de n'importe où et sur n'importe quel ordinateur",
        "Utilisez la grande bibliothèque d'exemples d'activités conformes aux normes ou créez les vôtres",
        "Les élèves peuvent accéder aux activités pédagogiques depuis n'importe quel ordinateur ou iPad à l'école ou à la maison",
        "Recueillez des données et suivez les progrès des élèves par rapport aux objectifs de leur programme individuel d'objectifs et aux normes éducatives",
        "Les outils intégrés vous aident à collaborer et à partager avec d'autres membres de l'équipe"
      ]
    },
    "summaryEnd": "Commencez votre période d’essai gratuite qui comprend un accès complet d’une durée de 30 jours !",
    "features": [
      {
        "featureTitle": "Créer et Éditer",
        "featureDescription": "Créez et modifiez des activités adaptées aux symboles, comme des séquentiels visuels pour planifier votre journée, des livres et du matériel d'apprentissage personnalisés ainsi que des soutiens au comportement ! Avec une bibliothèque de plus de 80 000 symboles parmi lesquels choisir et des nouveaux ajoutés toutes les deux semaines, les possibilités sont infinies. Vous avez besoin d’autre chose ? Utilisez notre option de recherche Web pour importer des fichiers multimédias dans votre projet."
      },
      {
        "featureTitle": "Imprimer et ouvrir",
        "featureDescription": "Imprimez vos propres activités, ou celles que vous trouverez dans la communauté Boardmaker, directement à partir de votre navigateur Web pour les utiliser avec votre enfant. Vous souhaitez améliorer la participation ? Essayez nos modèles et activités interactifs. Les enfants et les parents peuvent facilement effectuer des activités via l'application gratuite Student Center sur leur tablette ou dispositif de communication."
      },
      {
        "featureTitle": "Enseigner et prolonger",
        "featureDescription": "Aidez votre élève à franchir la prochaine étape de son parcours éducatif en accédant à trois programmes robustes et conformes aux normes. Inclus avec votre souscription myBoardmaker, Boardmaker Instructional Solutions comprend plus de 140 plans de cours étape par étape, plus de 1500 activités différenciées et conformes aux normes, plus de 300 livres imprimables et accessibles, des outils de gestion de classe, des quiz, des jeux, des recettes, de l'artisanat, et plus encore !"
      },
      {
        "featureTitle": "Rechercher et partager",
        "featureDescription": "Pourquoi réinventer la roue ? Choisissez parmi plus de 60 000 activités imprimées et interactives prêtes à l'emploi et GRATUITES et 1 100 groupes publics catégorisés dans la communauté Boardmaker - la plus grande communauté de partage de ce type au monde. Vous pouvez également télécharger les activités que vous avez créées sur votre compte communauté myBoardmaker et les partager avec des parents, thérapeutes ou l'équipe d'assistance de votre élève."
      },
      {
        "featureTitle": "Superviser et suivre",
        "featureDescription": "Supervisez et suivez les progrès de votre enfant pendant qu'il travaille sur les activités pour assurer son succès et vous aider à déterminer l'approche la plus efficace."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 ou plus tard"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 ou plus tard"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 ou plus tard"]
      ],
      "browser": [
        ["Chrome", "v49.0", "en cours"],
        ["Firefox", "v38.0", "en cours"],
        ["Safari", "v11.0", "en cours"],
        ["Edge", "v83.0.478.45", "en cours"],
        ["Internet Explorer", "v10.0", "v11.0 ou plus tard"]
      ]
    }
  },
  "organization": {
    "summary": "Boardmaker Online Organization soutient votre équipe multidisciplinaire en proposant des activités adaptées, des soutiens au comportement et une fonctionnalité d’évaluation des progrès vers les normes et les objectifs. \n\nLe système basé sur le cloud myBoardmaker fournit un cadre de travail à des fins de cohérence et de collaboration dans toute l'organisation et permet au personnel de travailler de n'importe où. De plus, il lui donne accès à une bibliothèque de plus de 60 000 activités prédéfinies, trois programmes complets et plus de 80 000 symboles de communication pour planifier ses cours. Désormais, votre personnel peut proposer rapidement des activités imprimées et interactives à ses élèves ou clients en utilisant Boardmaker Student Center pour approfondir l'apprentissage et la thérapie, le tout en un simple clic !n\nObservez l'utilisation par le personnel et améliorez l'efficacité dans toute votre organisation grâce à la possibilité de gérer les comptes et les données de manière centralisée, ainsi que des outils perfectionnés de partage et de collaboration.",
    "topReasons": {
      "header": "Les raisons principales pour vous inscrire à la communauté myBoardmaker Organization",
      "points": [
        "Le système basé sur le cloud fournit assure cohérence et collaboration dans toute l'organisation et permet au personnel de travailler de n'importe où.",
        "Vaste bibliothèque d'exemples d'activités déjà alignées sur les normes de préparation à l'université et à la carrière et aux normes spécifiques de votre état",
        "Les élèves peuvent accéder aux activités pédagogiques depuis n'importe quel ordinateur et de n’importe-où",
        "Les activités peuvent être associées aux objectifs du programme individuel d'objectifs pour illustrer les performances des élèves",
        "Accès immédiat aux données de performance des élèves et d’utilisation par le personnel, le tout à partir d'un seul système"
      ]
    },
    "summaryEnd": "",
    "features": [
      {
        "featureTitle": "Créer et Éditer",
        "featureDescription": "Créez et modifiez des activités adaptées aux symboles, comme des séquentiels visuels pour planifier votre journée, des livres et du matériel d'apprentissage personnalisés ainsi que des soutiens au comportement ! Avec une bibliothèque de plus de 80 000 symboles parmi lesquels choisir et des nouveaux ajoutés toutes les deux semaines, les possibilités sont infinies. Vous avez besoin d’autre chose ? Utilisez notre option de recherche Web pour importer des fichiers multimédias dans votre projet."
      },
      {
        "featureTitle": "Imprimer et ouvrir",
        "featureDescription": "Imprimez vos propres activités, ou celles que vous trouverez dans la communauté Boardmaker, directement à partir de votre navigateur Web. Vous souhaitez améliorer la participation ? Encouragez votre équipe à essayer nos modèles et activités interactifs. Les élèves peuvent facilement jouer à des activités via l'application gratuite et entièrement accessible Student Center sans connexion Internet nécessaire."
      },
      {
        "featureTitle": "Enseigner et approfondir",
        "featureDescription": "Offrez à votre personnel l'accès à trois programmes robustes et conformes aux normes, tous inclus dans votre souscription myBoardmaker Organization. Boardmaker Instructional Solutions comprend plus de 140 plans de cours étape par étape, plus de 1500 activités différenciées et conformes aux normes, plus de 300 livres imprimables et accessibles, des outils de gestion de classe, des quiz, des jeux, des recettes, de l'artisanat, et plus encore !"
      },
      {
        "featureTitle": "Affecter et suivre",
        "featureDescription": "Avec un compte myBoardmaker Organization, le personnel peut affecter des activités personnalisées et nivelées à un nombre illimité d’élèves afin de suivre leurs progrès individuels par rapport aux objectifs du programme individuel d'objectifs et aux normes nationales et locales. Il peut ensuite utiliser notre outil de suivi des progrès pour référencer rapidement les performances de ses élèves et rendre compte facilement de leur réussite. Les activités affectées effectuées à la maison sont également suivies afin que le personnel puisse gérer efficacement les devoirs et s’associer avec la famille de l’enfant pour approfondir l’apprentissage au-delà de la salle de classe."
      },
      {
        "featureTitle": "Rechercher et partager",
        "featureDescription": "Pourquoi réinventer la roue ? Choisissez parmi plus de 60 000 activités imprimées et interactives prêtes à l'emploi et GRATUITES et 1 100 groupes publics catégorisés dans la communauté Boardmaker - la plus grande communauté de partage de ce type au monde. Vous pouvez également télécharger les activités que vous avez créées sur votre compte communauté myBoardmaker et les partager avec des parents, thérapeutes ou l'équipe d'assistance de votre élève."
      }
    ],
    "advantages": [
      {
        "advantageTitle": "Économies",
        "advantagePoints": [
          "Forfaits d'organisation personnalisés exclusifs pour plus de 5 comptes",
          "Les services basés sur le cloud permettent une réaffectation facile des licences en tant que transaction concernant le personnel",
          "Tarification dégressive",
          "Lots multi-produits",
          "Économies sur plusieurs années"
        ]
      },
      {
        "advantageTitle": "Succès pour tous",
        "advantagePoints": [
          "Les activités prêtes à l'emploi et fondées sur des recherches garantissent des résultats positifs et mesurables",
          "Suivant les principes de la conception universelle pour l'apprentissage, nos matériels et activités pédagogiques adaptés rendent les objectifs d'apprentissage réalisables par des personnes ayant diverses capacités.",
          "Des programmes adaptés offrent un accès égal pour tous",
          "Ressources disponibles résumant les meilleures pratiques d'experts garantissant que vous tirez le meilleur parti de vos solutions"
        ]
      },
      {
        "advantageTitle": "Conforme aux normes et exigences",
        "advantagePoints": [
          "Solutions conçues spécifiquement pour enseigner et mesurer les progrès par rapport aux normes de préparation à l'université et à la carrière",
          "Large éventail de solutions conformes à la conception universelle pour l'apprentissage, la réussite de chaque enfant et les exigences de la loi sur l'éducation des personnes handicapées",
          "Suivez et rendez compte automatiquement des progrès accomplis par rapport aux objectifs du programme individuel d'objectifs via des tableaux de bord de données"
        ]
      },
      {
        "advantageTitle": "Déploiement facile au sein des organisations",
        "advantagePoints": [
          "Permet aux administrateurs de fournir et de déployer des comptes à distance en quelques secondes",
          "Options de déploiement au sein de l’organisation souples et évolutives",
          "Toutes les solutions basées sur le cloud sont hébergées dans un centre de données de niveau 1 hautement sécurisé",
          "Mises à jour automatiques gratuites basées sur le cloud avec de nouvelles fonctionnalités et ressources intéressantes"
        ]
      }
    ],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 ou plus tard"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 ou plus tard"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 ou plus tard"]
      ],
      "browser": [
        ["Chrome", "v49.0", "en cours"],
        ["Firefox", "v38.0", "en cours"],
        ["Safari", "v11.0", "en cours"],
        ["Edge", "v83.0.478.45", "en cours"],
        ["Internet Explorer", "v10.0", "v11.0 ou plus tard"]
      ]
    }
  },
  "boardmakerLicense": {
    "summary": "La nouvelle génération de logiciels Boardmaker est arrivée !  Boardmaker 7 reprend les meilleures fonctionnalités de toutes les versions précédentes de Boardmaker et les intègre dans une application multi-plateforme et multilingue.  Boardmaker 7 dispose d'une interface utilisateur simplifiée qui place les outils dont vous avez besoin à portée de main.  Boardmaker 7 comprend les derniers symboles PCS, mais il est rétrocompatible avec tous vos anciens tableaux et activités. Ce nouveau logiciel vous permettra de créer et de fournir des programmes et des soutiens à la communication adaptés plus rapidement que jamais.",
    "topReasons": {
      "header": "Les principales raisons pour acheter le logiciel Boardmaker 7",
      "points": [
        "Modifiez, imprimez et ouvrez tous vos anciens fichiers Boardmaker",
        "Interface intuitive et moderne avec des conseils et du matériel de formation intégrés",
        "Des modèles excellents, rapides et faciles à personnaliser",
        "Trouvez rapidement les symboles et les images dont vous avez besoin"
      ]
    },
    "summaryEnd": "Téléchargez votre essai gratuit de 30 jours dès aujourd'hui !",
    "features": [
      {
        "featureTitle": "Ouvre tout ce que vous avez fait",
        "featureDescription": "Ne perdez pas toutes vos années de travail acharné… avec le logiciel Boardmaker 7, vous pouvez ouvrir n'importe quel fichier créé avec Boardmaker v5, Boardmaker v6 ou Boardmaker Studio.  La conversion est rapide et précise, de sorte que même les activités interactives complexes fonctionneront et ressembleront à l'original."
      },
      {
        "featureTitle": "Facile, facile, facile",
        "featureDescription": "Les utilisateurs ont parlé !  Basée sur des tests utilisateurs approfondis avec des personnes comme vous, l'interface du logiciel Boardmaker 7 est moderne, accueillante et intuitive.  Les conseils intégrés et le matériel de formation vous donnent la confiance nécessaire pour explorer, développer vos compétences et, surtout, soutenir vos élèves."
      },
      {
        "featureTitle": "Rapide / Fait gagner du temps",
        "featureDescription": "Avec des modèles repensés pour les activités imprimées et interactives, vous serez étonné de l'ampleur et de l’étendue de ce que vous pouvez accomplir en quelques minutes.  Vous en aurez terminé avec ce programme ou ce récit social en un rien de temps, ce qui vous permettra ainsi de concentrer votre attention pour les étudiants que vous servez.  Boardmaker facilite également la personnalisation de ce que vous avez créé, de sorte que vous disposez de la combinaison idéale de vitesse et de flexibilité."
      },
      {
        "featureTitle": "Recherche de symboles améliorée",
        "featureDescription": "Les symboles sont ce que nous sommes. Boardmaker 7 propose une fonctionnalité de recherche de symboles améliorée et une manière intuitive de parcourir les symboles par catégorie… mais ce n'est que le début.  Vous pouvez rechercher des fragments de mots, des mots qui riment, des phonèmes individuels et des modèles de consonnes/ voyelles. C'est l'outil de recherche le plus puissant disponible !  Et juste au cas où vous ne trouveriez pas un symbole en particulier, la recherche Web intégrée et les outils de caméra vous permettent d'ajouter des photos rapidement et facilement"
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "10", "Windows 10 ou plus tard"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 ou plus tard"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 ou plus tard"]
      ]
    }
  },
  "studio": {
    "requirements": {
      "operatingSystem": [["Windows OS", "7", "Windows 10"]]
    }
  },
  "scmp": {
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "7", "Windows 10"],
        ["iOS", "6.0", "IOS 6.0 ou version ultérieure"],
        ["Android", "Dispositifs Tobii Dynavox T-Series", ""]
      ],
      "eyeTracker": [
        [
          "PCEye Mini,",
          "PCEye Explore,",
          "PCEye Go,",
          "EyeMobile,",
          "I-12,",
          "I–15"
        ]
      ]
    }
  }
}
